import { BlobResponse, RemoteAdminData } from 'app/infrastructure/remote-data/remote-data';
import { ApiResponse } from 'app/types-shared';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { endpoint } from './endpoints';
import { SearchApiResponse } from './types';
import { ExtraInfoCodeValues } from 'app/components/access-panel/shared/types';

export const api = {

  getUsers: async (startIndex: number, maxResults: number, model: FilterSearchModel) => {

    const response: any = await new RemoteAdminData(endpoint.user)
      .resource<ApiResponse<SearchApiResponse>>()
      .filter({ startIndex, maxResults })
      .create(model, false);

    return await response.json();
  },

  getRoles: async (startIndex: number, maxResults: number, model: FilterSearchModel) => {

    const response: any = await new RemoteAdminData(endpoint.role)
      .resource<ApiResponse<SearchApiResponse>>()
      .filter({ startIndex, maxResults })
      .create(model, false);

    return await response.json();
  },

  userExportToExcel: async (startIndex: number, maxResults: number, model: FilterSearchModel): Promise<BlobResponse> => {
    return await new RemoteAdminData(endpoint.userExportToExcel)
      .resource<BlobResponse>()
      .filter({ startIndex, maxResults })
      .blob(model);
  },

  roleExportToExcel: async (startIndex: number, maxResults: number, model: FilterSearchModel): Promise<BlobResponse> => {
    return await new RemoteAdminData(endpoint.roleExportToExcel)
      .resource<BlobResponse>()
      .filter({ startIndex, maxResults })
      .blob(model);
  },

  getExtraInfo: () => {
    return new RemoteAdminData(endpoint.extraInfo)
      .resource<ApiResponse<ExtraInfoCodeValues[]>>()
      .single();
  }
};
